import { z } from "zod";
import { WrappedWebTriggerEditorMessageSchema } from "./web-trigger-editor";
import { WrappedWebSDKMessageSchema } from "./web-sdk";
import { WrappedWebPaywallJSMessageSchema } from "./web-paywall-js";
import { WrappedWebPaywallEditorMessageSchema } from "./web-paywall-editor";
export const MessageEventsSchema = z.discriminatedUnion("_type", [
    WrappedWebTriggerEditorMessageSchema,
    WrappedWebSDKMessageSchema,
    WrappedWebPaywallJSMessageSchema,
    WrappedWebPaywallEditorMessageSchema
]);
export * from "./web-sdk";
export * from "./web-trigger-editor";
export * from "./web-paywall-js";
export * from "./web-paywall-editor";
